module.exports = __webpack_public_path__ + "285d06609e99981e0f76dfc5baaa55d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/blow-dryer.png
// module id = 1989
// module chunks = 0